import { useEffect, useState } from "react";
import Heading from "../../components/Heading";
import UploadIcon from '../../utils/media/icons/upload_icon.png';
import Card from "./components/Card";
import { ActionButton } from "../../components/Forms/ActionButton";
import { fetchAllMedia } from "../../api/media";
import { useGetAllMedia } from "../../queries/media";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TableList from "./components/TableList";
import Loader from "../../components/Common/Loader";

const MediaLibrary = () => {

    const [selectedTab, setSelectedTab] = useState('card-view'); // [ card-view, list-view ]

    const [mediaData, setMediaData] = useState([]);

    const { data, isLoading, isError } = useGetAllMedia();
    
    const renderMediaCards = mediaData && mediaData.map(media => (
        <Card
            key={media.key}
            name={media.key}
            image={media.url}
            size={media.size}
            uploaded={new Date(media.lastModified).toLocaleDateString()}
        />
    ));
    
    useEffect(() => {
        // fetchAllMedia(setMediaData, toast);
        if(data) {
            setMediaData(data);
        }
    }, [data, isLoading]);
    
    const renderTab = () => {
        if (selectedTab === 'card-view') {
            return (
                <div className="flex flex-col w-full mt-7">
                    <div className="flex justify-end items-center">
                        <select name="filter" id="filter" className="bg-navBtn px-4 py-2 rounded-md outline-none">
                            <option value="">Filter</option>
                            <option value="Image">Image</option>
                            <option value="Video">Video</option>
                            <option value="File">File</option>
                        </select>
                    </div>
                    <div className="flex flex-wrap w-full mt-5 gap-3">
                        {/* Card */}
                        {renderMediaCards}
                    </div>
                </div>
            );
        }
        else if (selectedTab === 'list-view') {
            return (
                <TableList data={mediaData} />
            );
        }
    }

    // if(mediaData.length === 0) {
    //     return (
    //         <div className="flex flex-col items-center justify-center w-full">
    //             <Heading text={'No Media Found!'} />
    //         </div>
    //     );
    // }
    
    if(isLoading) {
        return (
            <div className="flex h-96 w-full justify-center items-center">
                <Loader />
            </div>
        );
    }
    
    return (
        <div className="flex flex-col p-5 w-full">
            <Heading
                text={'Media Library'}
            />

            {/* Tabs */}
            <div className='my-4 flex gap-2'>
                <button
                    className={`font-bold text-sm flex-grow rounded-md py-2 border-2 ${selectedTab === 'card-view' ? 'bg-white' : 'bg-navBtn'} ${selectedTab === 'card-view' ? 'border-primary' : 'border-navBtn'}`}
                    onClick={() => setSelectedTab('card-view')}
                >
                    Card View</button>
                <button
                    className={`font-bold text-sm flex-grow rounded-md py-2 border-2 ${selectedTab === 'list-view' ? 'bg-white' : 'bg-navBtn'} ${selectedTab === 'list-view' ? 'border-primary' : 'border-navBtn'}`}
                    onClick={() => setSelectedTab('list-view')}
                >
                    List View</button>
            </div>

            <div className="flex flex-col bg-white p-5 w-full shadow-[0px_4px_25px_rgba(94,92,154,0.1)] max-md:pt-24 rounded-md">
                <div>
                    <h2 className="font-semibold">Media</h2>
                    <div className="flex p-12 justify-center items-center border border-navBtn w-full rounded-md">
                        <div className="flex flex-col justify-center items-center p-6 px-32 border border-dashed border-navBtn rounded-lg">
                            <img src={UploadIcon} alt="upload" className="fill-primary" />
                            <input
                                type="file"
                                className="hidden"
                                id="fileInput"
                                // onChange={(e) => setImage(e.target.files[0])}
                            />
                            <label
                                htmlFor="fileInput"
                                className="cursor-pointer py-2 px-4 text-sm font-semibold rounded hover:bg-navBtn"
                            >Upload Media</label>
                            {/* <p className=" text-base">Upload Media</p> */}
                            <p className="text-secondary text-xs">Maximum 3 Media</p>
                        </div>
                    </div>
                </div>
                {/* Search-bar */}
                <div className="w-full mt-5">
                    <input
                        type="text"
                        name="search"
                        placeholder="Search..."
                        id="search"
                        className="border border-navBtn rounded-md px-5 py-2 w-full"
                    />
                </div>
                <div className="flex items-center justify-end mt-10 gap-3">
                    <ActionButton
                        variant={'reset'}
                        text={'Reset'}
                    />
                    <ActionButton
                        variant={'submit'}
                        text={'Search'}
                    />
                </div>
            </div>
            
            {renderTab()}
            <ToastContainer 
                position = "top-right"
                autoClose={1000}
            />
        </div>
    );
}

export default MediaLibrary;